import React, { Suspense } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import NavigationBar from "./components/navigationbar/NavigationBar";
import HomePage from "./pages/HomePage/HomePage";
import MainPage from "./pages/HomePage/MainPage";
import ContactPage from "./pages/contactPage/ContactPage";
import Loading from "./components/loading/Loading";
import CompanyProfile from "./pages/companyProfile/CompanyProfile";
import Main from "./pages/HomePage/Main";
import Services from "./pages/services/ServicesPage";
import Projects from "./pages/projectsPage/Projects";

function App() {
  return (
    <div>
      <HashRouter>
        <Suspense>
          <Routes>
            <Route path="/" element={<NavigationBar />}>
              <Route path="/" element={<Main />} />

              <Route path="/mainpage" element={<MainPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/company_profile" element={<CompanyProfile />} />
              <Route path="/services" element={<Services />} />
              <Route path="/projects" element={<Projects />} />

              {/* <Route path="/footer" element={<Footer />} /> */}
            </Route>
            <Route path="/loading" element={<Loading />} />
          </Routes>
        </Suspense>
      </HashRouter>
    </div>
  );
}

export default App;
